import { CollideEvent, CollideId } from '../../defs/collide';
import type { CornBlockEntity } from '../../entities/BlockEntity';
import { despawnBlockEntity } from '../../entities/BlockEntity';
import { GameScene } from '../../GameScene';
import { CornEffect } from '../effects/CornEffect';
import { InvalidEffect } from '../effects/InvalidEffect';
import { CollideHandler, ICollision } from './ICollision';

export class CornCollision implements ICollision {
  private readonly scene: GameScene;
  private readonly entity: CornBlockEntity;
  private readonly resolvers: { [key in CollideId]?: CollideHandler } = {
    tap: this.resolveTap,
    block: this.resolveBlock,
    attack: this.resolveAttack,
  };

  constructor(scene: GameScene, entity: CornBlockEntity) {
    this.scene = scene;
    this.entity = entity;
  }

  public async resolve(event: CollideEvent): Promise<boolean> {
    return this.resolvers[event.id]?.call(this, event) ?? false;
  }

  private async resolveTap(event: CollideEvent) {
    await new InvalidEffect(this.entity).execute();
    return false;
  }

  private async resolveBlock(event: CollideEvent) {
    const collider = event.collider;

    // Attack only if basic block collider
    if (
      collider?.type === 'block' &&
      collider.entity.c.block.props.type === 'basic'
    ) {
      await this.attack();
      return true;
    }
    return false;
  }

  private async resolveAttack(event: CollideEvent) {
    await this.attack();
    return true;
  }

  private async attack() {
    // Despawn the block - will be replaced by popcorn block on CornEffect
    despawnBlockEntity(this.scene, this.entity);

    // Play corn effect, that will spawn popcorn block
    await new CornEffect(this.scene, {
      subject: this.entity,
      spawnPopcorn: true,
    }).execute();
  }
}
